import {
  CLIENT_GET_REQUESTING,
  CLIENT_GET_SUCCESS,
  CLIENT_GET_ERROR,
  CLIENT_GET_RANKING_REQUESTING,
  CLIENT_GET_RANKING_SUCCESS,
  CLIENT_GET_RANKING_ERROR
} from "./constants";

import { AUTH_LOGOUT_SUCCESS, AUTH_SUCCESS } from "../auth/reducer";

const initialState = {
  clientId: localStorage.getItem("clientId"),
  userId: localStorage.getItem("userId"),
  allActions: [],
  role: "user",
  owner: "",
  domain: "",
  name: "",
  list: [],
  client: "",
  error: null,
  requesting: false,
  feelingEvolution: [],
  firstFeeling: [],
  userRanking: [],
  teamRanking: [],
  actionsSelected: [],
  totalEmployees: 123
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case CLIENT_GET_REQUESTING: {
      return {
        ...state,
        requesting: true
      };
    }

    case CLIENT_GET_SUCCESS: {
      return {
        ...state,
        ...action.payload,
        requesting: false
      };
    }

    case CLIENT_GET_RANKING_SUCCESS: {
      return {
        ...state,
        ...action.payload
      };
    }

    case CLIENT_GET_ERROR: {
      return { ...state, error: action.payload, requesting: false };
    }

    case AUTH_SUCCESS: {
      const { clientId, userId } = action;
      return { ...state, clientId, userId };
    }

    case AUTH_LOGOUT_SUCCESS: {
      return { ...initialState, clientId: "", userId: "", role: "" };
    }

    default:
      return state;
  }
};

export default reducer;
